// extracted by mini-css-extract-plugin
export default {"overlay":"RecrutimentDashboard_overlay__ZkDEW","closebtn":"RecrutimentDashboard_closebtn__+XkK8","searchContainer":"RecrutimentDashboard_searchContainer__tn-+v"};